
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import debounce from 'lodash/debounce';
import {
  Client,
  IJobNoteModel,
  JobNoteModel
} from '@/services/api.service';
import vSelect from 'vue-select';
import { EventBus } from '@/event-bus';
import { JobNoteUpdatedMessage } from '@/services/eventbus.models';
import toISODateFormatter from '@/filters/toISOdate.formatter';
import * as StringUtils from '@/utilities/string.utils';

@Component({
  components: {
    vSelect
  },
  props: {
    jobNote: {
      type: Object as () => IJobNoteModel,
      required: false
    },
    jobGid: String,
    isInDialogMode: Boolean,
    jobNumber: String
  },
  filters: {
    toISODate: toISODateFormatter
  }
})
export default class JobNoteEdit extends Vue {

  public notes: string = '';

  protected mounted() {
    // get the networks
    if (this.$props.jobNote) {
      this.notes = this.$props.jobNote.notes;
    }
  }

private updateJobNote() {
    console.log('updating job note');
    const me = this;
    const updateModel: IJobNoteModel = {
      notes: this.notes,
      gid: this.$props.jobNote.gid,
      jobGid: this.$props.jobNote.jobGid,
      jobItemGid: this.$props.jobNote.jobItemGid,
      createdByUserGid: this.$props.jobNote.createdByUserGid,
      createdDateTime: this.$props.jobNote.createdDateTime
    };

    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    // @ts-ignore
    this.$Progress.start();
    console.log('Updating job note:' + this.$props.jobNote.gid);
    clientService.updateJobNote(this.$props.jobGid, this.$props.jobNote.gid, new JobNoteModel(updateModel)).then(data => {
      // Route to the edit client screen?
      // @ts-ignore
      this.$Progress.finish();
      // @ts-ignore
      this.$awn.success('Job note updated successfully');
      this.$emit('job-note-updated', data);
      EventBus.$emit('job-note-updated', new JobNoteUpdatedMessage(this.$props.jobGid, data));
      this.closeModal();
    });
  }
  private cancelEdit() {
    console.log('Cancelling edit...');
    // this.$emit('close');
    this.closeModal();
  }

  private closeModal() {
    this.$modal.hide('modal-jobnote-edit');
  }
}
